//bundle quantity change
Shopify.theme.quantityBoxForBundle = {
  init: function init() {
    $('body').on('click', '[data-update-bundle-quantity]:not([disabled])', function () {
      Shopify.theme.quantityBoxForBundle.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.bundle-quantity-input', function () {
      Shopify.theme.quantityBoxForBundle.updateQuantity($(this));
    });
  },
  updateQuantity: function updateQuantity($el) {
    var $quantityBox = $el.parents('.product-quantity-box');
    var $input = $('.bundle-quantity-input', $quantityBox);
    var lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    var val = parseInt($input.val());
    var valMax = 100000000000000000;
    var valMin = $input.attr('min') || 0;

    var bundleKeys = $input.data('bundle-keys').split(',').filter(Boolean);
    
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (isNaN(val) || val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-bundle-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-bundle-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } // Update quantity if within cart (vs on the product page)


    if ($el.parents('[data-line-item]').length) {
      var _lineID = $quantityBox.data('line-item-key');
      Shopify.theme.quantityBoxForBundle.updateCart(bundleKeys, _lineID, val);
    }
  },
  updateCart: function updateCart(keys, lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    var updateString = '';
    $.each(keys, function(index, key){
      updateString += 'updates['+key+']='+quantity;
      if(index < keys.length - 1){
        updateString += '&';
      }
    });
    //console.log(updateString); return false;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: updateString,
      dataType: 'json',
      success: function success(cart) {
        var newQuantity = 0;
        var itemsLeftText = '';
        var quantityWarning = $("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-warning');
        var $quantityBox = $("[data-line-item=\"".concat(lineID, "\"]")).find('.product-quantity-box'); //check to see if there are correct amount of products in array
		var bundleComponentQty = 0
        
        $.each(cart.items, function(count, item){
          if(item.product_type != 'bundle' && item.properties['bundle']){
            bundleComponentQty += item.quantity;
          }
        });
        
        cart.item_count -= bundleComponentQty;
        
        var cartItemsLineID = lineID - 1;

        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }

        if (quantity > 0 && quantity != newQuantity) {
          if (newQuantity == 1) {
            itemsLeftText = Shopify.translation.product_count_one;
            quantityWarning.text("".concat(newQuantity, " ").concat(itemsLeftText));
            $('.quantity-minus', $quantityBox).attr('disabled', true);
          } else {
            itemsLeftText = Shopify.translation.product_count_other;
            quantityWarning.text("".concat(newQuantity, " ").concat(itemsLeftText));
          }
        } // Apply quantity warning


        quantityWarning.addClass('animated bounceIn');

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.updateView(cart, lineID);
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  unload: function unload($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
//bundle remove from cart
if (typeof Shopify.theme.jsCart !== 'undefined') {
  Shopify.theme.jsCart.removeFromCartBundle = function(lineID, updateString) {
    var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    $cartItem.css('opacity', '0.5');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: updateString,
      dataType: 'json',
      success: function success(cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();
        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  };
}
if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
  Shopify.theme.jsAjaxCart.removeFromCartBundle = function(lineID, updateString, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: updateString,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  }
}
jQuery(function($){
//   $.getJSON('/cart.js', function(cart){  
//   	console.log(cart);
//   });
  //update main variant selector with option change for bundle components
  $(document).on('change', '.bundle--variant-option-selector', function(){
    var $allOptionsContainer = $(this).closest('.select-container');
    var $mainVariantSelector = $allOptionsContainer.find('.bundle--variant-selector');
    var $form = $(this).closest('form');
    var optionString = '';
    if($(this).parent().hasClass('option-1')){
      var option2Arr = $(this).find('option[value="'+$(this).val()+'"]').data('option2') ? $(this).find('option[value="'+$(this).val()+'"]').data('option2').split(',') : null;
      var option3Arr = $(this).find('option[value="'+$(this).val()+'"]').data('option3') ? $(this).find('option[value="'+$(this).val()+'"]').data('option3').split(',') : null;
      
      if(option2Arr){
      	var option2html = '<option value="" selected disabled>Select An Option</option>';
        $.each(option2Arr, function(optIn, optVal){
          if(optVal) option2html += '<option value="'+optVal+'">'+optVal+'</option>';
        });
        //console.log(option2html);
        $allOptionsContainer.find('.option-2 select').html(option2html);
      }
      if(option3Arr){
      	var option3html = '<option value="" selected disabled>Select An Option</option>';
        $.each(option3Arr, function(optIn, optVal){
          if(optVal) option3html += '<option value="'+optVal+'">'+optVal+'</option>';
        });
        $allOptionsContainer.find('.option-3 select').html(option3html);
      }
    }
    $allOptionsContainer.find('.bundle--variant-option-selector').each(function(i){
      optionString += $(this).val();
      if(i < $allOptionsContainer.find('.bundle--variant-option-selector').length - 1){
        optionString += '/';
      }
    });
    if($mainVariantSelector.find('option[data-option-string="'+optionString+'"]').length){
      //console.log(optionString);
      $mainVariantSelector.val($mainVariantSelector.find('option[data-option-string="'+optionString+'"]').attr('value')).trigger('change');
    } 
  });
  //update bundle product property upon variant change
  $(document).on('change', '.bundle--variant-selector[name="id[]"]', function(){
    var $form = $(this).closest('form');
  	var $bundleVariantSelectors = $form.find('.bundle--variant-selector[name="id[]"]');
    var propertyString = '';
    var allAvailable = true;
    var noOptionSelected = false;
    $bundleVariantSelectors.each(function(i){
      if($(this).val()){
        propertyString += $(this).val();
        if(i < $bundleVariantSelectors.length - 1){
          propertyString += ',';
        }
        if($(this).find('option[value="'+$(this).val()+'"]').data('available') == false) allAvailable = false;
        if($(this).data('available') == false) allAvailable = false;
      } else {
        noOptionSelected = true; return false;
      }
    });
    //console.log(noOptionSelected);
    if(noOptionSelected) return;
    $form.find('[name="properties[bundle_items]"]').val(propertyString);
    $form.find('.purchase-details').css({'display': 'flex'});
    if(allAvailable){
      $form.find('button[name="add"]').prop('disabled', false);
      $form.find('button[name="add"] span.text').html($form.find('button[name="add"]').data('label'));
    } else {
      $form.find('button[name="add"]').prop('disabled', true);
      $form.find('button[name="add"] span.text').html($form.find('button[name="add"]').data('soldout-text'));
    }
  });
  //update 1of product variant area for bundle components
  $(document).on('change', '.bundle--1of-products-selector', function(){
    var $container = $(this).closest('.bundle--1of-products-container');
    var $form = $(this).closest('form'); 
    var selectorstr = '.bundle--1of-product-options-'+$(this).val();
    var option1 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option1');
    var option2 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option2') || null;
    var option3 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option3') || null;
    $container.find(selectorstr).siblings().removeClass('active');
    $container.find(selectorstr).siblings().each(function(){
      $(this).find('.bundle--variant-selector').removeAttr('name');
    });
    $container.find(selectorstr).addClass('active');
    $container.find(selectorstr+ ' .bundle--variant-selector').attr('name', 'id[]');
    $form.find('.purchase-details').css({'display': 'none'});
//     $container.find(selectorstr+ ' .option-1 .bundle--variant-option-selector').val(option1).trigger('change');
//     if(option2){
//       $container.find(selectorstr+ ' .option-2 .bundle--variant-option-selector').val(option2).trigger('change');
//     }
//     if(option3){
//       $container.find(selectorstr+ ' .option-3 .bundle--variant-option-selector').val(option3).trigger('change');
//     }
  });
  
  //update 2of product variant area for bundle componenets
  $(document).on('change', '.bundle--2of-products-selector', function(){
    var $container = $(this).closest('.bundle--2of-products-container');
    var $form = $(this).closest('form'); 
    var selectorstr = '.bundle--2of-product-options-'+$(this).val();
    var option1 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option1');
    var option2 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option2') || null;
    var option3 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option3') || null;
    $container.find(selectorstr).siblings().removeClass('active');
    $container.find(selectorstr).siblings().each(function(){
      $(this).find('.bundle--variant-selector').removeAttr('name');
    });
    $container.find(selectorstr).addClass('active');
    $container.find(selectorstr+ ' .bundle--variant-selector').attr('name', 'id[]');
    $form.find('.purchase-details').css({'display': 'none'});
//     $container.find(selectorstr+ ' .option-1 .bundle--variant-option-selector').val(option1).trigger('change');
//     if(option2){
//       $container.find(selectorstr+ ' .option-2 .bundle--variant-option-selector').val(option2).trigger('change');
//     }
//     if(option3){
//       $container.find(selectorstr+ ' .option-3 .bundle--variant-option-selector').val(option3).trigger('change');
//     }
  });
  //update 3of product variant area for bundle componenets
  $(document).on('change', '.bundle--3of-products-selector', function(){
    var $container = $(this).closest('.bundle--3of-products-container');
    var $form = $(this).closest('form'); 
    var selectorstr = '.bundle--3of-product-options-'+$(this).val();
    var option1 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option1');
    var option2 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option2') || null;
    var option3 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option3') || null;
    $container.find(selectorstr).siblings().removeClass('active');
    $container.find(selectorstr).siblings().each(function(){
      $(this).find('.bundle--variant-selector').removeAttr('name');
    });
    $container.find(selectorstr).addClass('active');
    $container.find(selectorstr+ ' .bundle--variant-selector').attr('name', 'id[]');
    $form.find('.purchase-details').css({'display': 'none'});
//     $container.find(selectorstr+ ' .option-1 .bundle--variant-option-selector').val(option1).trigger('change');
//     if(option2){
//       $container.find(selectorstr+ ' .option-2 .bundle--variant-option-selector').val(option2).trigger('change');
//     }
//     if(option3){
//       $container.find(selectorstr+ ' .option-3 .bundle--variant-option-selector').val(option3).trigger('change');
//     }
  });
  //update 4of product variant area for bundle componenets
  $(document).on('change', '.bundle--4of-products-selector', function(){
    var $container = $(this).closest('.bundle--4of-products-container');
    var $form = $(this).closest('form'); 
    var selectorstr = '.bundle--4of-product-options-'+$(this).val();
    var option1 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option1');
    var option2 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option2') || null;
    var option3 = $(this).find('option[value="'+$(this).val()+'"]').attr('data-sofav-option3') || null;
    $container.find(selectorstr).siblings().removeClass('active');
    $container.find(selectorstr).siblings().each(function(){
      $(this).find('.bundle--variant-selector').removeAttr('name');
    });
    $container.find(selectorstr).addClass('active');
    $container.find(selectorstr+ ' .bundle--variant-selector').attr('name', 'id[]');
    $form.find('.purchase-details').css({'display': 'none'});
//     $container.find(selectorstr+ ' .option-1 .bundle--variant-option-selector').val(option1).trigger('change');
//     if(option2){
//       $container.find(selectorstr+ ' .option-2 .bundle--variant-option-selector').val(option2).trigger('change');
//     }
//     if(option3){
//       $container.find(selectorstr+ ' .option-3 .bundle--variant-option-selector').val(option3).trigger('change');
//     }
  });
  //trigger bundle remove from cart function
  if (typeof Shopify.theme.jsCart !== 'undefined') {
    $(document).on('click', '[data-cart-bundle-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).data('line-item-key');
      var updateString = $(this).attr('href').split('?')[1];
      Shopify.theme.jsCart.removeFromCartBundle(lineID, updateString);
      return false;
    });
  }
  if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
    $(document).on('click', '[data-ajax-cart-bundle-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      var updateString = $(this).attr('href').split('?')[1];
      Shopify.theme.jsAjaxCart.removeFromCartBundle(lineID, updateString);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCartBundle(lineID, updateString);
      }

      return false;
    });
  }
  Shopify.theme.quantityBoxForBundle.init();
});



